import React, { useContext } from "react";
import { TableContainer, Paper } from "@material-ui/core";

import {
  STOCKPILES_TABLE_COLUMNS_NUMBER,
  STOCKPILES_TABLE_FEATURES,
} from "../../constants";
import { MatchContext } from "../../context";
import EmptyTable from "./components/empty-table.component";
import FilledTable from "./components/filled-table.component";
import useStyles from "../tables-container/styles";

export default function StockpilesTable({
  handleChangeTableInputs,
  handleChangeTableWeights,
}): JSX.Element {
  const { state } = useContext(MatchContext);
  const classes = useStyles();

  return (
    <div className="stockpiles-table">
      <TableContainer
        component={Paper}
        className={!state.hideMatchingTable && classes.container}
      >
        {!state.showStockpileData ? (
          <EmptyTable
            columnsNumber={STOCKPILES_TABLE_COLUMNS_NUMBER}
            handleChangeTableInputs={handleChangeTableInputs}
            handleChangeTableWeights={handleChangeTableWeights}
            stockpilesTableFeatures={STOCKPILES_TABLE_FEATURES}
          />
        ) : (
          <FilledTable
            handleChangeTableInputs={handleChangeTableInputs}
            handleChangeTableWeights={handleChangeTableWeights}
            stockpilesTableFeatures={STOCKPILES_TABLE_FEATURES}
          />
        )}
      </TableContainer>
    </div>
  );
}
